module.exports = __webpack_public_path__ + "img/sokal-logo-white.214ac3e3.png";